<template>
  <v-container text-xs-center>
    <div id="app">
      <v-card>
        <v-card-title>
          Users List
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="700px" persistent>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">{{
                formTitle
              }}</v-btn>
            </template>
          </v-dialog>
        </v-card-title>
      </v-card>
      <v-app id="inspire">
        <v-data-table
          :headers="headers"
          :items="usersList.edges"
          :search="search"
          :footer-props="rowsPerPageItems"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          item-key="node.userId"
          show-expand
          dense
        >
          <template v-slot:top>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.userId"
                          label="User ID"
                          disabled
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.userName"
                          label="User Name"
                          :rules="nameRules"
                          :counter="50"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="editedItem.birthDate"
                              label="Birth Date"
                              prepend-icon="event"
                              v-on="on"
                              readonly
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="editedItem.birthDate"
                            @input="menu = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>

                      <v-flex xs12 sm6 md4>
                        <v-select
                          class="hidden-xs-only"
                          v-model="editedItem.countryId"
                          :items="countryList()"
                          label="Country"
                          :rules="requiredRule"
                          item-value="node.valId"
                          item-text="node.valDesc"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-select
                          v-model="editedItem.gender"
                          :items="['male', 'female']"
                          label="Gender"
                          :rules="requiredRule"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.userEmail"
                          label="E-Mail"
                          :rules="emailRules"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.language"
                          label="Language"
                          filled
                          disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.country"
                          label="Country"
                          filled
                          disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-switch
                          color="secondary"
                          v-model="editItem.state"
                          label="State"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                          v-model="editedItem.photo"
                          label="Photo"
                          readonly
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" text @click="close">Cancel</v-btn>
                  <v-btn
                    :disabled="!isFormValid"
                    color="secondary"
                    text
                    @click="save"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item.node)">
              edit
            </v-icon>
            <v-icon small @click="deleteItem(item.node)"> delete </v-icon>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-data-table
                v-if="item.node.userAccess.edges != undefined"
                :headers="subHeaders"
                :items="item.node.userAccess.edges"
                dense
                hide-default-footer
              >
              </v-data-table>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-app>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      expanded: [],
      singleExpand: false,
      search: "",
      isFormValid: true,
      menu: false,
      on: true,
      dialog: false,
      rowsPerPageItems: {
        "items-per-page-options": [50, 100, 150, -1]
      },
      pagination: {
        rowsPerPage: 15
      },
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 50) || "Name must be less than 10 characters"
      ],
      requiredRule: [v => !!v || "Value is required"],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || // eslint-disable-line
          "E-mail must be valid"
      ],
      headers: [
        {
          text: "User Name",
          align: "left",
          sortable: true,
          value: "node.userName"
        },
        { text: "User Email", value: "node.userEmail" },
        { text: "Gender", value: "node.gender" },
        { text: "CreateDate", value: "node.createDate" },
        { text: "Birth Date", value: "node.birthDate" },
        { text: "Country", value: "node.country" },
        { text: "State", value: "node.state" },
        { text: "Language", value: "node.language" },
        { text: "Role", value: "node.role" },
        { text: "User Id", value: "node.userId" },
        { text: "Actions", value: "action", sortable: false }
      ],
      subHeaders: [
        // { text: "SeqNo", align: "left", sortable: true, value: "node.seqNo"},
        { text: "UserId", value: "node.club.clubName" },
        //{ text: "ClubId", value: "node.clubId" },
        { text: "Access Level", value: "node.accessLevel" }
      ],
      editedIndex: -1,
      editedItem: {
        "node.userId": "",
        "node.userName": "",
        "node.userEmail": "",
        "node.gender": "",
        "node.createDate": "",
        "node.birthDate": "",
        "node.country": "",
        "node.state": "",
        "node.language": "",
        "node.role": ""
      },
      defaultItem: {
        "node.userId": "",
        "node.userName": "",
        "node.userEmail": "",
        "node.gender": "",
        "node.createDate": "",
        "node.birthDate": "",
        "node.country": "",
        "node.state": "",
        "node.language": "",
        "node.role": ""
      }
    };
  },
  created() {
    this.handleGetUsersList();
  },
  mounted() {},
  computed: {
    ...mapGetters(["loading", "usersList", "categoryValue"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },

  watch: {},

  methods: {
    countryList() {
      return this.categoryValue.edges
        .filter(category => category.node.category)
        .filter(category => category.node.category.catName == "COUNTRY_LIST");
    },
    handleGetUsersList() {
      //reach out of Vuex store, fire action that gets posts for carousel
      if (this.usersList === undefined || this.usersList.length == 0) {
        this.$store.dispatch("allUser");
      }
    },
    userMutate() {
      this.$store.dispatch("userMerge", {
        userId: this.editedItem.userId || 0,
        userName: this.editedItem.userName,
        userEmail: this.editedItem.userEmail,
        //photo: this.editedItem.photo,

        // visibility: this.editedItem.state ? 1 : 0, // this.editedItem.visibility,
        // countryId: this.editedItem.country,
        // createDate: this.editedItem.clubId ? this.currentDate : this.currentDate,
        //createDate: this.editedItem.clubId ? this.currentDate : this.editedItem.createDate,
        updateSource: "VueJS tst"
      });
    },
    userDelete() {
      this.$store.dispatch("userDelete", {
        userId: this.editedItem.userId
      });
    },

    editItem(item) {
      this.editedIndex = this.usersList.edges.findIndex(x => x.node === item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.editedTwice = 1;
    },

    deleteItem(item) {
      const index = this.usersList.edges.findIndex(x => x.node === item);
      this.editedItem = Object.assign({}, item);

      confirm("Are you sure you want to delete this item?") &&
        // this.handleGetClubInfo.splice(index, 1);
        this.userDelete(index);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      this.userMutate();
      /*
      if (this.editedIndex > -1) {
        Object.assign(
          this.handleGetClubInfo.toString()[this.editedIndex],
          this.editedItem
        );
      } else {
        
        // this.handleGetClubInfo.push(this.editedItem);
        this.handleAddAthlete;
      }*/
      this.close();
    }
  }
};
</script>
